import { Component, OnInit } from '@angular/core';
import { ObservablesService } from '../observables.service'
import { trigger, state, style, transition, animate} from '@angular/animations';
@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)',
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)',
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('backDrop', [
      state('in', style({
        display: 'block',
      })),
      state('out', style({
        display: 'none',
      }))
    ]),
  ]
})
export class UserLayoutComponent implements OnInit {
  menuState:string = 'out';
  menuObserver:any
  constructor(private observables:ObservablesService) {
    this.menuObserver = this.observables.menuStatus.subscribe((data:any)=>{
       this.menuState = data.menuState
    });
  }

  ngOnInit() {
  }

  closeMenu(){
    this.observables.setMenuStatus({menuState:'out'})
  }

  ngOnDestroy(){
    this.menuObserver.unsubscribe()
  }

  public partySelected(partyData: any) {
    // console.log("emited",partyData)
    // this.partyData=partyData;
    this.observables.getSelectedPartyData(partyData)
  }

  public dateRangeChanged(dateRange:any){
    // console.log("selected date rangess=",dateRange)
    this.observables.getSelectedDateRangeData(dateRange)
  }
  public headerDataChanged(data:any){
    // console.log("selected data=",data)
    this.observables.setHeaderData.next(data)
  }

}
